// Copyright © 2021 Move Closer
import { TokenType } from '@d24/demarked';
import { AbstractAdapter } from '../_abstract/adapter';
import { EmbedVersion } from './Embed.contracts';
import { EmbedIframeAdapter } from './versions/iframe/EmbedIframe.adapter';
import { EmbedPdfAdapter } from './versions/pdf/EmbedPdf.adapter';
import { EmbedYouTubeAdapter } from './versions/youtube/EmbedYouTube.adapter';
import { EmbedTwitterAdapter } from './versions/twitter/EmbedTwitter.adapter';
import { EmbedVideoAdapter } from './versions/video/EmbedVideo.adapter';
import { EmbedVideoSwitchAdapter } from './versions/videoSwitch/EmbedVideoSwitch.adapter';
/**
 * Registry that binds the `TokenType` with the applicable adapter.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const tokenTypeAdapterRegistry = {
    [TokenType.Embed]: new EmbedIframeAdapter(),
    [TokenType.EmbedPdf]: new EmbedPdfAdapter(),
    [TokenType.EmbedTwitter]: new EmbedTwitterAdapter(),
    [TokenType.EmbedYouTube]: new EmbedYouTubeAdapter(),
    [TokenType.EmbedVideo]: new EmbedVideoAdapter(),
    [TokenType.EmbedVideoSwitch]: new EmbedVideoSwitchAdapter()
};
/**
 * Registry that binds the `TokenType` with the applicable adapter.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const embedVersionAdapterRegistry = {
    [EmbedVersion.Iframe]: new EmbedIframeAdapter(),
    [EmbedVersion.PDF]: new EmbedPdfAdapter(),
    [EmbedVersion.Twitter]: new EmbedTwitterAdapter(),
    [EmbedVersion.YouTube]: new EmbedYouTubeAdapter(),
    [EmbedVersion.Video]: new EmbedVideoAdapter(),
    [EmbedVersion.VideoSwitch]: new EmbedVideoSwitchAdapter()
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export class EmbedAdapter extends AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `EmbedModule` to the `EmbedToken` or `EmbedYouTubeToken`.
     *
     * @param object - The module to adapt.
     * @param storage
     */
    objectToToken(object, storage) {
        if (!(object.version in embedVersionAdapterRegistry)) {
            throw new Error(`EmbedAdapter.objectToToken(): There's no applicable adapter for the object with of given driver!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        return embedVersionAdapterRegistry[object.version].objectToToken(object, storage);
    }
    /**
     * Adapts (translates/maps) the passed-in `EmbedToken` or `EmbedYouTubeToken` to the `EmbedModule`.
     *
     * @param token - The token to adapt.
     * @param storage
     */
    tokenToObject(token, storage) {
        if (!(token.type in tokenTypeAdapterRegistry)) {
            throw new Error(`EmbedAdapter.tokenToObject(): There's no applicable adapter for the token with of given type!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        return tokenTypeAdapterRegistry[token.type].tokenToObject(token, storage);
    }
}
